export const LeftDrawerContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => <>{children}</>;

export const MainPaneContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => <>{children}</>;
